<template>
    <div class="auth-callback">
        <p>{{ message }}</p>
    </div>
</template>

<script>
export default {
    name: 'AuthCallback',
    data() {
        return { message: '授权处理中，请稍候…', timer: null, attempts: 0 }
    },
    mounted() {
        const query = new URLSearchParams(window.location.search)
        const orderNo = query.get('authState') || localStorage.getItem('antom_order_no')
        if (!orderNo) {
            this.message = '缺少授权订单信息，请重新进入页面'
            return
        }
        this.timer = window.setInterval(async () => {
            this.attempts += 1
            if (this.attempts > 30) {
                window.clearInterval(this.timer)
                this.message = '授权仍在处理中，请稍后刷新查询'
                return
            }
            try {
                const response = await fetch(`/api/antom/token/${encodeURIComponent(orderNo)}`)
                const result = await response.json()
                const status = result && result.data && result.data.status
                if (status === 'ACTIVE') {
                    window.clearInterval(this.timer)
                    this.message = '授权成功'
                    window.setTimeout(() => this.$router.replace('/pay-success'), 500)
                } else if (status === 'FAILED' || status === 'REVOKED') {
                    window.clearInterval(this.timer)
                    this.message = '授权未完成，请重新尝试'
                }
            } catch (error) {
                console.error('查询Antom授权状态失败', error)
            }
        }, 2000)
    },
    beforeDestroy() {
        if (this.timer) window.clearInterval(this.timer)
    }
}
</script>

<style scoped>
.auth-callback { padding: 48px 20px; color: #fff; background: #ef612f; min-height: 100vh; }
</style>
